export const translations = {
  en: {
    venue_title: "TAURON Arena Kraków",
    venue_subtitle: "Food & Beverage",
    all_zones: "All",
    food_trucks: "Arena Garden",
    kiosks: "SnackBar",
    vip: "VIP",
    view_menu: "View Menu",
    outlets_count: "outlets",
    always_open: "Always open",
    event_only: "Open during events",
    powered_by: "Powered by",
    loading: "Loading menus...",
    error: "Failed to load menus",
    retry: "Try again",
    zone_food_truck_desc: "Food truck zone",
    zone_kiosk_desc: "Gastronomic points",
    zone_vip_desc: "Premium dining experience",
    deposit_note: "Deposit refunds are made ONLY via the same payment method. A receipt is required for the refund, and a confirmation in case of card payments.",
    back_home: "Home",
    spirits_menu: "Spirits Menu",
  },
  pl: {
    venue_title: "TAURON Arena Kraków",
    venue_subtitle: "Gastronomia",
    all_zones: "Wszystko",
    food_trucks: "Arena Garden",
    kiosks: "SnackBar",
    vip: "VIP",
    view_menu: "Zobacz menu",
    outlets_count: "punktów gastronomicznych",
    always_open: "Zawsze otwarta",
    event_only: "Otwarta podczas wydarzeń",
    powered_by: "Powered by",
    loading: "Ładowanie menu...",
    error: "Nie udało się załadować menu",
    retry: "Spróbuj ponownie",
    zone_food_truck_desc: "Strefa foodtruck",
    zone_kiosk_desc: "Punkty gastronomiczne",
    zone_vip_desc: "Restauracje premium",
    deposit_note: "Zwrot kaucji odbywa się WYŁĄCZNIE tą samą metodą płatności. Do zwrotu kaucji wymagany jest paragon oraz potwierdzenie w przypadku płatnością kartą.",
    back_home: "Strona główna",
    spirits_menu: "Alkohole premium",
  },
};
